import React, { useState, useEffect,useContext} from 'react';
import { useNavigate,useParams} from 'react-router-dom';
import Button from '../../../../Components/Button';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

import { GlobalContext } from '../../../../GlobalContext';

const UnitAddUsers = () => {
    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('Add users');
    });
    const { groupId } = useParams();
    const token = localStorage.getItem('unittoken');
    const decodedToken = jwtDecode(token);
    const userId ={userID: decodedToken.id};

    useEffect(() => {
        const fetch = async () => {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            await axios.post(`${POCBaseUrl}/unitgroups/unitgetone`, {groupId},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response => {
                console.log('response',response.data, response.data.data.name);
                // setGroupData(response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
        }
        fetch();
    }, []);

    const gotoGroupList = () => {
        navigate(`/unitgrouplist`); // Use navigate for routing
    };

    return (
        <>
            <div className="mt-2.5 bg-[#f0f0f0] rounded-[5px]" style={{ fontFamily: 'Liberation Serif' }}>
                <div className="bg-[rgb(240,240,240)] w-full mb-[2px] flex items-center">
                    <div className="bg-[#f0f0f0] w-[200px] py-[10px] border-r-2 border-[#fff] flex items-center flex-row">
                        <span className='text-center w-[200px] text-[#5a5655] text-[14px]'>Group Name</span>
                    </div>
                    <div className='ml-[10px]'>
                        <span className='mr-[10px] text-center w-[200px] text-[#2776c3] text-[14px]'>Group Name</span>
                    </div>
                </div>
                <div className="bg-[rgb(240,240,240)] w-full mb-[2px] flex items-center border-t-2 border-[#fff]">
                    <div className="h-[437px] bg-[#f0f0f0] w-[200px] py-[10px] border-r-2 border-[#fff] flex items-center flex-row">
                        <div className="bg-[#f0f0f0] w-[200px] py-[10px] border-r-2 border-[#fff] flex items-center flex-row">
                            <span className='text-center w-[200px] text-[#5a5655] text-[14px]'>Add/delete users</span>
                        </div>
                    </div>
                    <div className='w-full items-center flex flex-row'> 
                        <div className='ml-[8px] w-full flex flex-col'>
                            <div className='items-center flex flex-col'>
                                <span className='text-[22px] font-semibold text-[#2776c3]'>In-group users</span>
                            </div>
                            <div className='w-full itmes-center flex flex-row'>
                                <div className='inline-block w-full'>
                                    <input
                                        type = {'text'}
                                        autoComplete="off"
                                        placeholder={'Keys words for in group users'}
                                        className={`bg-white border border-[#dcdfe6] rounded-[4px] box-border text-black inline-block text-inherit h-[40px] leading-[40px] outline-0 px-[15px] transition-colors duration-200 ease-[cubic-bezier(.645,.045,.355,1)] w-full`}
                                    />
                                </div>
                                <Button children={'Search'}/>
                            </div>
                            <div className='mt-[2px] h-[350px] bg-white overflow-auto'>

                            </div>
                        </div>
                        <div className="flex flex-row mr-[20px] my-0 ml-[30px] " style={{ fontFamily: 'Liberation Serif' }}>
                            <div className='w-[40px] flex flex-col mt-[50px] items-center'>
                                <div className='w-full relative group'>
                                    <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAmCAYAAABtT3M/AAAACXBIWXMAAAsSAAALEgHS3X78AAABjElEQVRYhe2ZMU7DMBSG/1bdyw3aDW/0AJbITegN6MQbmzUTvQFwAugJqMTbKZs30iPkBCBXDkIoDLWfnaTKN3XJy/viP7bjji7v3hYAdgCm6B8VgGziBDJT6H3fFBTxcQDGdgT6KGBxfU/HHeglmEGiK5yFxMTnIkVcAliZQr9INKGIv+rfptCjU6/3HYkZgGdFvFPEc88aYoTG6RrApyLOFfFFXyVq1gD2ingpVO8kJF9sG7EHF7FFgt5/iDE72Yi9K+JNqojFnGJvAZSKeBXxHkdirxN2Z3yviO37ksW6SarF7grAqyJ+jDElp16xb9wslksWbWPbYSO2tqu+VMS8th1CzFzEtqHl2t4AVu7LMog2JZ4AzE2hN6GF2ojTh9sBB49ATUoJG51c4sn/JZXE1j39Mkbx2BIHAEvJ6DQRS8JGZ2MKLbqo/UcMiajRaUJSIkl0mpCQSBqdJkIlkkenCV+Jg+SRTSheEqbQot8EPmdNvxmOMbvCINEVrESV+rBLCtd31f8/HoHsG0CWd9FMbaeoAAAAAElFTkSuQmCC"
                                    alt=""
                                    className="py-[10px] w-[40px] border-0 "
                                    />
                                    <div
                                    className="max-w-xs absolute shadow-lg hidden group-hover:block bg-[#333] text-white font-medium px-3 py-[6px] text-[12px] right-0 left-[-12px] top-[-30px] mx-auto w-max -top-10 rounded before:w-4 before:h-4 before:rotate-45 before:bg-[#333] before:absolute before:z-[-1] before:-bottom-1 before:left-0  before:right-0 before:mx-auto">
                                    Delete All</div>
                                </div>
                                <div className='w-full relative group'>
                                    <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAmCAYAAABtT3M/AAAACXBIWXMAAAsSAAALEgHS3X78AAABq0lEQVRYhe2ZMVLDMBBFl0x6cwS6qHMO4MI3IDcInAAq1ELpCjhB4ATADTIT9TidSo6Ab8Aos64MdvZLO2Mz+XV2tE/7dyUrZ4u73ZKItkSU0fTUEFE5Z4DSV0U9NQRj3aEAs1CBKQIEcd7ZbAS5ROsEMRapQhjramPdhTarCIKTOheE5ERU8xRRk7QSIamtcHczjlmNBYLA3Q0gb8a6K2C9QaE90e6u1CYbY91TZM4dxTR2APkEdvfGWPci7K1epZhOGwBkzZVMApJqxCI2yUFLdpTynDjYRBiTBCT1Ybc21r0LbdIOCXhyaZzYl4DfM7bkLbKg1rUj5+8UqR4BS6renXIwrrXk/NiAsd5ivyU/PpoW0B6sxquvClGTa1UiAJRA3LUUgJQgPvjhQWKJhgHETU0KdhJboX12iXmsSFmJZwAg2G4Z+9qSqhKIFfaA7X5VCggEALHdn4qBQL384KviPmLdjlAIFACeQH1CIIKXV74qvgQxDccg96lBSSGQZoweoUMSQfiqkH68JJtAfdK8OyHQkE5vsWPRv4FotB98tcR5N9P/45Go/AHM36GRmW8UBQAAAABJRU5ErkJggg=="
                                    alt=""
                                    className="py-[10px] w-[40px] border-0"
                                    />
                                     <div
                                    className="max-w-xs absolute shadow-lg hidden group-hover:block bg-[#333] text-white font-medium px-3 py-[6px] text-[12px] right-0 left-[-40px] top-[-30px] mx-auto w-max -top-10 rounded before:w-4 before:h-4 before:rotate-45 before:bg-[#333] before:absolute before:z-[-1] before:-bottom-1 before:left-0  before:right-0 before:mx-auto">
                                    Delete selected users</div>
                                </div>
                                <div className='w-full relative group'>
                                    <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAmCAYAAABtT3M/AAAACXBIWXMAAAsSAAALEgHS3X78AAABt0lEQVRYhe2ZMU7EMBBFP6vtlxtQ4o4cwBLhBnsDwg2gwSVQutsbADeAGwThnqVzyw3IDZDRrIjECjJjj5TA/n40fvl/bMvZO7x8rgC0ABaYnjoA9ZwA6ujtemoIxoVPA2bJgSkCJNG6F7MRrCVbO4ixSB3CuLBvXFCdOVUI2j0SwBGjJkG3nD5z0eqGLYZ9/iQAqhkMDS0njAsNgBcmANu1jYpDGBeuAdwyazauHUh6FoUwLtwBuGLWLHOvPUVmgrL8AOCYWddwXdumbCd6w8gFOC8BgFwnJDsQvmJ3mtO7L7ET0iyXBoDUCUmWpWfAELGdMC6shFlWAQDXicwoqADgX95io7dpFm6EvV6Fdb+K7UT0Nl0rzgS9ai0QUZyit2k2Tui1YWjNe/Q2nSv3kp4/STwT0duWvu4bs64pDZI12PTaUHFjQiAXOb37yt6dUkzIkUdm3Uo4W99UZIulvC+5MZHM1jYVPSckMenNlhik+GHXiwln51rnbMEqJzbFhPV1c0DUrh2SRfU2iSdOL9W7kxQkeltz+qi9O21EX7fS7LF7ix2L/gxER68WkxOtu5v+j0eg/gCDzKKICpICOwAAAABJRU5ErkJggg=="
                                    alt=""
                                    className="py-[10px] w-[40px] border-0"
                                    />
                                    <div
                                    className="max-w-xs absolute shadow-lg hidden group-hover:block bg-[#333] text-white font-medium px-3 py-[6px] text-[12px] right-0 left-[-35px] top-[-30px] mx-auto w-max -top-10 rounded before:w-4 before:h-4 before:rotate-45 before:bg-[#333] before:absolute before:z-[-1] before:-bottom-1 before:left-0  before:right-0 before:mx-auto">
                                    Add selected users</div>
                                </div>
                                <div className='w-full relative group'>
                                    <img
                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAmCAYAAABtT3M/AAAACXBIWXMAAAsSAAALEgHS3X78AAABp0lEQVRYhe2ZPU7EQAyF3662X24AVEy59CMRTsAeAU4ANEwJlNOFG8AN4AZBzAGgcwk3ICcAGbziR0HaTTyTDNpXpYnlJ3+ZsZ3RztnDDEAFYIr8VAMoJmKgIG8fc7NgXPgowJgrkKMBluQ9HQ8gl85amxiK/oWJSZuXjAtvi2fydqSRiHGhAHBN3m6t+m4rE5oyLnDSJYCDtmF7xcm4cAGAj8nWBtBXJRboANjUiJfUhKDDye9pxk1iwriwAeAEwHmM+NFNGBfm+PxwVdBpUjQTsdBpkroJQYdPnWPt2H9J1YRx4VDQSTqbqJiQvr5MgU6TOpswLpQp0WmSxo3Nk+GLfmrLq7MJ8vYWAON0mTDvH1LpncjbV/KWT6RtAPd66S0n1QaQvH0mb7kvOpJNRBJF6WLJW77k+LK7ytYEvhDjfmk3NmLR5wleqwhip7EQSzYUkbelIHajHTvpZCeIcWuyD+BJK24v4yl5W5G3My3Eep2xvyF21yVO73snQWwuiLVqX1o1gFq7pl8xK6nKylqvMYeitYmhiE3UMl5mJ8m7zv/HI1C8A4zXcuP6hVKmAAAAAElFTkSuQmCC"
                                    alt=""
                                    className="py-[10px] w-[40px] border-0"
                                    />
                                    <div
                                    className="max-w-xs absolute shadow-lg hidden group-hover:block bg-[#333] text-white font-medium px-3 py-[6px] text-[12px] right-0 left-[-12px] top-[-30px] mx-auto w-max -top-10 rounded before:w-4 before:h-4 before:rotate-45 before:bg-[#333] before:absolute before:z-[-1] before:-bottom-1 before:left-0  before:right-0 before:mx-auto">
                                    Add all</div>
                                </div>
                            </div>
                        </div>
                        <div className='ml-[8px] mr-[10px] w-full flex flex-col'>
                            <div className='items-center flex flex-col'>
                                <span className='text-[22px] font-semibold text-[#2776c3]'>Not-in-group users</span>
                            </div>
                            <div className='w-full itmes-center flex flex-row'>
                                <div className='inline-block w-full'>
                                    <input
                                        type = {'text'}
                                        autoComplete="off"
                                        placeholder={'Keys words for not-in-group users'}
                                        className={`bg-white border border-[#dcdfe6] rounded-[4px] box-border text-black inline-block text-inherit h-[40px] leading-[40px] outline-0 px-[15px] transition-colors duration-200 ease-[cubic-bezier(.645,.045,.355,1)] w-full`}
                                    />
                                </div>
                                <Button children={'Search'}/>
                            </div>
                            <div className='mt-[2px] h-[350px] bg-white overflow-auto'>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex mt-2.5 bg-[#f0f0f0]' style={{ fontFamily: 'Liberation Serif' }}>
                <button onClick={gotoGroupList} className='inline-block mt-2.5 mb-2.5 ml-[202px] bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Return to the list
                </button>
            </div>
        </>
    );
}

export default UnitAddUsers;